import React, { useState , useEffect } from "react";
import { useSelector } from "react-redux";
import {useDispatch} from 'react-redux';

import { useUser } from "../../state/reactquery";
import { initialiseLeadactu , modifyEcran,  defineMessage , modifyDisplaymodal,
    defineMessagetexte , defineTypeMail , defineObjet , defineEmailchoice } from "../../state/redux";


import { getallformules } from "../../utils/calculstarifs";
import { formatdatenotif } from "../../utils/utils_dates";
import { modifyMailRead  } from "../../utils/utils_email";
import { axios_clients_searchclientbyid } from "../../axios/axios_clients";
import { axios_email_search , axios_email_searchbyid } from "../../axios/axios_email";


import ButtonImgLeft from "../../Components/Buttons/ButtonImgLeft";
import FavoriMail from "./FavoriMail";
import FavoriSelect from "./FavoriSelect";
import DivOneMail from "./DivOneMail";
 


import './EcranEmails.scss' ;
const classNames = require('classnames');
function  EcranEmails({emails,type}){
    const dispatch = useDispatch(); 
    const { emailchoice} = useSelector(state=>state.email);
    const leadactu = useSelector(state=>state.lead.leadactu);

    const {data: user} = useUser(localStorage.getItem('token')) ;

    const [choice , setChoice] = useState('selectemailsentrants')  ;

    const [namesearch, setNameseach]  = useState('')  ;
    const [leadmail, setLeadmail] = useState(null) ;
    const [emailsaffiches, setEmailsaffiches] = useState([]) ;
    const [selectfavoris , setSelectfavoris] = useState(false)  ;
    const mailbox  = type==='user'?(user?.postmail):user.email_gestion ; 
    const titre = type==='user'?"Messagerie Clients":"Messagerie Gestion"; 

    const emailcrmlike = type==='user'? user.postmail?.split('@')[0]:user.email_gestion?.split('@')[0];


    const mailsnonouverts = emails?.emailsentrants?.filter(x=>x.RecordType!=='Open');
    const emails_IN = emails?.emailsentrants?.sort((a,b) => new Date(b.created_at) - new Date(a.created_at)) ;
    const emails_OUT =  emails?.emailssortants?.sort((a,b) => new Date(b.created_at) - new Date(a.created_at)) ;
    const emailsaffichesselected   = selectfavoris? emailsaffiches?.filter(m=>m.favori===1): emailsaffiches ; 
    
    useEffect(()=>{choice==='selectemailsentrants' ?setEmailsaffiches(emails_IN) : setEmailsaffiches(emails_OUT)},[choice,emails_IN,emails_OUT])  ;

    const searchmail =async (e)=>{
        if (e.key === 'Enter') { 
            const toto = await axios_email_search(e.target.value?.trim(),mailbox);
            setEmailsaffiches(toto.data) ;dispatch(defineEmailchoice(null)); 
         }
    }

    const changenamesearch =(e)=>{ ;
        setNameseach(e.target.value);
        if(e.target.value?.length ===0){return }

        const emails1 = emailsaffiches.filter(x=>x.nom?.toLowerCase()?.includes(e.target.value?.toLowerCase())) ;
        const emails2 = emailsaffiches.filter(x=>x.prenom?.toLowerCase()?.includes(e.target.value?.toLowerCase())) ;
        const emails3 = emailsaffiches.filter(x=>x.emailFrom?.toLowerCase()?.includes(e.target.value?.toLowerCase())) ;
        const emails4 = emailsaffiches.filter(x=>x.emailTo?.toLowerCase()?.includes(e.target.value?.toLowerCase())) ;

        const listmails = [...new Set([...emails1,...emails2,...emails3,...emails4])]

        setEmailsaffiches(listmails);
    }



    const gotothislead =async()=>{ if(!leadactu?.id){ return }
        dispatch(getallformules());  dispatch(modifyEcran('ficheclient'));
    }



    
    const choiceemail =async (e)=>{
        dispatch(defineObjet('')); 
        if(e.target.className.includes('mailfavori')){ return  ;}
        setLeadmail({}) ;
        const reqemail = await axios_email_searchbyid(e.currentTarget.id) ;
        const  messagtechoiced =  reqemail.data;
        dispatch(defineEmailchoice(messagtechoiced)); 
        const reqclient = await  axios_clients_searchclientbyid(messagtechoiced?.id_lead) ; 
        setLeadmail(reqclient.data) ;
         dispatch(initialiseLeadactu(reqclient.data||{})) ;  
       if(messagtechoiced?.RecordType!=='Open'&&  messagtechoiced.emailTo?.includes(emailcrmlike) ){  
            modifyMailRead(type,messagtechoiced?.id)
        }


    }


const classmail =(recordtype) =>{
    return recordtype==='Open'? 'openmail':
            recordtype==='Delivery'? 'deliverymail':
            recordtype==='SubscriptionChange'? 'subscribemail':
            recordtype==='Click'? 'openmail':
            recordtype==='Bounce'? 'bouncemail':
            recordtype==='SpamComplaint'? 'complaintmail':
            recordtype=== 'HardBounce'? 'bouncemail':
            recordtype==='error'? 'errormail':
            recordtype==='success'? 'successmail':'unknowntypemail'
 }  



 const clickbouton = ()=>{
    dispatch(defineObjet('')); 
    const objetmail = emailchoice?.Subject?.length >0 ? emailchoice?.Subject : 'Nouveau message' ;
    choice==='selectemailsentrants' && dispatch(defineObjet(objetmail))
    dispatch(defineMessage('')) ;
    dispatch(defineMessagetexte(''));
    dispatch(defineTypeMail(type==='user'?'comtoclient':'gestiontoclient'));
    dispatch(modifyDisplaymodal('mod_mailingmodal'))  ;
}


const mail_button = (message)=>(<div key={message?.id} id={message?.id} onClick={choiceemail}
                                     className={classNames("mailbutton",{"emailselected":message?.id===emailchoice?.id },{"emailnonlu":message.RecordType!=='Open'})}>
                                  <div className="mailbutton_initiales" >{message?.nom?.[0]}{message?.prenom?.[0]}  </div>
                                  <div className='mailbutton_details'  >
                                         <div className={`mailbutton_details_recordtype `+classmail(message?.RecordType)} >{message?.RecordType}  </div>
                                        <div className="mailbutton_details_time" >{formatdatenotif(message?.created_at)}  </div>
                                        <div className="mailbutton_details_nomprenom" >{message?.nom} {message?.prenom}  {type==='gestion' && message?.emailTo}   </div>
                                        <div className="mailbutton_details_subject" >{message?.Subject}</div>
                                        <FavoriMail choice={choice} message={message} type={type} />
                                  </div>
                                </div>);


    const choicemailsentrants = () =>{setChoice('selectemailsentrants'); setEmailsaffiches(emails_IN);dispatch(defineEmailchoice(emails_IN?.[0]));dispatch(defineEmailchoice(null));  }
    const choicemailssortants = () =>{setChoice('selectemailsortants');setEmailsaffiches(emails_OUT); dispatch(defineEmailchoice(emails_OUT?.[0]));dispatch(defineEmailchoice(null)); }
    return(<>
 
    <div className="container_screenmails">
                 <div className="ecranmails_left">
                        <div className="ecranmails_titre">{titre}</div>
                        <div className="ecranmails_left_top">
                            <div className={classNames("ecranmails_left_top_btn",{"btnchoiced":choice==="selectemailsentrants"})} onClick={choicemailsentrants}  >Messages reçus <div className="nbmailsnonouverts">{mailsnonouverts?.length}</div>  </div>
                            <div className={classNames("ecranmails_left_top_btn",{"btnchoiced":choice==="selectemailsortants"})}  onClick={choicemailssortants}   >Messages envoyés</div>
                        </div>
                        {/* <ButtonImgLeft texte="Nouveau message"
                                            color='bouton_color_orange' 
                                            size='bouton_size_normal' 
                                            image='imagemail' 
                                            onclick= {newmessage}  /> <br/> */}
                        <div className="flexinpurcoeur">
                        <input className={classNames("ecranmails_left_search",{"inputchoiced":choice==='selectemailsearch'})}  
                                placeholder="Rechercher un nom"
                                value={namesearch} 
                                onFocus={()=>setChoice('selectemailsearch')} 
                                onChange={changenamesearch}  
                                onKeyUp={searchmail}   />

                        <FavoriSelect    selectfavoris={selectfavoris}  setSelectfavoris={setSelectfavoris}    />
                            
                        </div>

                        <div className="ecranmails_left_liste">
                            {emailsaffiches?.length >0 && emailsaffichesselected.map(email => mail_button(email)  )}
                        </div>
                 </div>
                 <div className="ecranmails_right">
                   {emailchoice && <div className="ecranmails_right_top">
                            {leadmail && <><div className={classNames("ficheclienttopleft_flamme", { "cold": leadmail?.hot === 0 }, { "hot": leadmail?.hot === 1 })}  ></div>
                            <div className="ficheclienttopleft_avatar"  >
                                <div className="avatar">  {(leadmail?.nom && leadmail?.prenom) ? leadmail?.nom[0] + leadmail?.prenom[0] : leadmail?.email ? leadmail?.email[0] : ''} </div>
                            </div>
                                <div  className="ecranmails_right_top_texte"   > {  leadmail?.nom ? leadmail?.nom + ' ' + leadmail?.prenom : leadmail?.email}
                                    {(leadmail?.statut_client?.includes('rdv')) ? <span className='statutcontacttop'> RDV </span> : <></>}
                                    {(leadmail?.statut_client?.includes('relance')) ? <span className='statutcontacttop'> RELANCE  </span> : <></>}
                                    {(leadmail?.statut_client?.includes('nrp')) ? <span className='statutcontacttop'> NRP </span> : <></>}
                                </div> 
                            <div  className="ecranmails_right_gotolead" onClick={gotothislead}   >      
                            </div></>}
                            <div className="ecranmails_right_fromto">De {emailchoice.emailFrom} à {emailchoice.emailTo} </div>
                    </div>}
                    { emailchoice &&   <div className="ecranmails_right_bottom">
                 
                         <DivOneMail  />

                       <div className="boutontorigth">
                            <ButtonImgLeft texte={choice==='selectemailsentrants'?"Répondre":"Ecrire un message"}
                                            color='bouton_color_orange' 
                                            size='bouton_size_normal' 
                                            image='imagemail' 
                                            onclick= {clickbouton}  /> 
                        </div>
                 
                    </div>}
                 </div>
</div></>)
}

export default EcranEmails;